module.exports = "/img/_/_/_/assets/images/creeper/battle/common//10.jpg?95b842816f73c6193d2bc55633c6f93b";